import { render, staticRenderFns } from "./company-manager.vue?vue&type=template&id=901f68f8&"
import script from "./company-manager.vue?vue&type=script&lang=js&"
export * from "./company-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports